// 하드코딩 되어있어서 추후에 다시..
export const shiftGbName = (shift_gb: string) => {
  switch (shift_gb) {
    case "O":
      return "오프";
    case "null":
      return "휴무 휴가 등";
    case "고정":
      return "고정근무";
    default:
      return shift_gb; //기본 Shift _Gb
  }
};

export const getShiftGroupConfig = () => {
  // 메인 그룹 코드 (예: "O")
  const MAIN_GROUP_CODE = "O";
  // 서브코드로 처리할 코드들 (예: "주")
  const SUB_CODE_LIST = ["주"];

  return {
    MAIN_GROUP_CODE,
    SUB_CODE_LIST,
    isMainGroup: (defaultShift: string | null) =>
      defaultShift === MAIN_GROUP_CODE,
    isSubCode: (defaultShift: string | null) =>
      SUB_CODE_LIST.includes(defaultShift || ""),
    isInMainGroup: (defaultShift: string | null) =>
      defaultShift === MAIN_GROUP_CODE ||
      SUB_CODE_LIST.includes(defaultShift || ""),
  };
};
